export default "#include <cstdio>\n\n__global__ void kernel() {\n    printf(\"Hello World!\\n\");\n}\n\nint main() {\n    kernel<<<1, 1>>>();\n}\n"